import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OptionInterface } from '../../../../core/models/option.interface';

@Component({
  selector: 'app-select-field',
  templateUrl: './select-field.component.html',
  styleUrls: ['./select-field.component.css']
})
export class SelectFieldComponent {
  @Input() id: string;
  @Input() controlName: string;
  @Input() key: string;
  @Input() form: FormGroup;
  @Input() options: OptionInterface[];
  @Input() class = 'field field-select';
  @Input() empty = false;
  @Input() placeholder = false;
  @Input() hideLabel = false;
  @Input() hideErrors = false;
  @Output() change = new EventEmitter<any>();
  @ViewChild('error') error;
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/select-field/select-field.component.ts